import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {AiChatUser} from '../models/ai-chat-user.model';
import {AiChatSessionStateStore} from '../state/ai-chat-session-state.store';
import {AiChatModule} from '../ai-chat.module';
import {getCurrentUserId, getSessionSignature, setCurrentUserId} from './ai-chat-auth-session';

const CURRENT_USER_URL = '/core/users/getCurrentUser/json';

@Injectable({
  providedIn: 'root',
})
export class AiChatUserService {
  constructor(
    private readonly http: HttpClient,
    private readonly stateStore: AiChatSessionStateStore,
  ) {}

  ensureUser(): Observable<AiChatUser | null> {
    const currentSessionSignature = getSessionSignature();
    const persistedState = this.stateStore.getState();

    if (
      persistedState?.sessionSignature &&
      persistedState.sessionSignature !== currentSessionSignature
    ) {
      this.stateStore.clear();
    }

    const cachedUser = this.stateStore.getState()?.user;
    if (cachedUser?.id && getCurrentUserId()) {
      return of(cachedUser);
    }

    return this.http
      .get<AiChatUser>(CURRENT_USER_URL, {headers: AiChatModule.NO_CACHE_HEADERS})
      .pipe(
        tap((user) => {
          if (user?.id) {
            setCurrentUserId(user.id);
            this.stateStore.patchState({
              user,
              sessionSignature: getSessionSignature(),
            });
          }
        }),
        catchError(() => of(null)),
      );
  }
}
